/**
 * 通知管理 store 模块
 */
import {
  createNotice as apiCreate,
  deleteNotice as apiDelete,
  getNoticeDetail,
  getNoticesList,
  normalizeNoticeDetailPayload,
  normalizeNoticeListPayload,
  updateNotice as apiUpdate
} from '@/api/notices'

export default {
  namespaced: true,
  state: {
    list: [],
    total: 0,
    loading: false,
    error: null
  },
  getters: {
    notices: state => state.list,
    noticeTotal: state => state.total,
    loading: state => state.loading,
    error: state => state.error
  },
  mutations: {
    SET_LIST(state, payload) {
      state.list = payload.list || []
      state.total = payload.total ?? state.list.length
    },
    SET_LOADING(state, value) {
      state.loading = !!value
    },
    SET_ERROR(state, value) {
      state.error = value || null
    }
  },
  actions: {
    async fetchList({ commit }, params = {}) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const response = await getNoticesList(params)
        const normalized = normalizeNoticeListPayload(response, params.page_size ?? 10)
        commit('SET_LIST', { list: normalized.list, total: normalized.count })
        return normalized
      } catch (error) {
        commit('SET_ERROR', error.message || '加载通知失败')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchOne(_, id) {
      const response = await getNoticeDetail(id)
      return normalizeNoticeDetailPayload(response)
    },
    async create({ dispatch }, payload) {
      const response = await apiCreate(payload)
      await dispatch('fetchList', { page: 1, page_size: 10 }).catch(() => {})
      return normalizeNoticeDetailPayload(response)
    },
    async update({ dispatch }, { id, data }) {
      const response = await apiUpdate(id, data)
      await dispatch('fetchList', { page: 1, page_size: 10 }).catch(() => {})
      return normalizeNoticeDetailPayload(response)
    },
    async remove({ dispatch }, id) {
      const response = await apiDelete(id)
      await dispatch('fetchList', { page: 1, page_size: 10 }).catch(() => {})
      return response
    }
  }
}
